var _defs, _rect, _rect2, _line, _circle, _circle2, _rect3, _rect4, _rect5, _rect6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpFieldPositions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 450,
    viewBox: "0 0 700 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grass",
    patternUnits: "userSpaceOnUse",
    width: 40,
    height: 450
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 450,
    fill: "#2d7a2d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 20,
    height: 450,
    fill: "#267026"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "textbg",
    x: -0.05,
    y: -0.05,
    width: 1.1,
    height: 1.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255,255,255,0.6)",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "expanded"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "bg",
    in2: "expanded",
    operator: "in",
    result: "bgmask"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "bgmask"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 450,
    fill: "url(#grass)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 660,
    height: 410,
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 20,
    x2: 350,
    y2: 430,
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 225,
    r: 61,
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 225,
    r: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 93,
    width: 112,
    height: 225,
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 568,
    y: 93,
    width: 112,
    height: 225,
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 184,
    width: 14,
    height: 82,
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 184,
    width: 14,
    height: 82,
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "position_markers"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 105,
    r: 10,
    fill: "#ff0000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 105,
    r: 10,
    fill: "#00ff00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 105,
    r: 10,
    fill: "#00ff00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 105,
    r: 10,
    fill: "#00ff00"
  }), /*#__PURE__*/React.createElement("text", {
    x: 102.5,
    y: 185,
    fontSize: 17,
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    fill: "#1a1a1a",
    textAnchor: "middle",
    filter: "url(#textbg)"
  }, "Home"), /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 215,
    fontSize: 17,
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    fill: "#1a1a1a",
    textAnchor: "middle",
    filter: "url(#textbg)"
  }, "Own Half"), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 185,
    fontSize: 17,
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    fill: "#1a1a1a",
    textAnchor: "middle",
    filter: "url(#textbg)"
  }, "Midfield"), /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 215,
    fontSize: 17,
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    fill: "#1a1a1a",
    textAnchor: "middle",
    filter: "url(#textbg)"
  }, "Opponent Half"), /*#__PURE__*/React.createElement("line", {
    x1: 102.5,
    y1: 167,
    x2: 102.5,
    y2: 120,
    stroke: "#1a1a1a",
    strokeWidth: 2,
    markerEnd: "url(#arrowhead)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 197,
    x2: 185,
    y2: 120,
    stroke: "#1a1a1a",
    strokeWidth: 2,
    markerEnd: "url(#arrowhead)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 167,
    x2: 350,
    y2: 120,
    stroke: "#1a1a1a",
    strokeWidth: 2,
    markerEnd: "url(#arrowhead)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 515,
    y1: 197,
    x2: 515,
    y2: 120,
    stroke: "#1a1a1a",
    strokeWidth: 2,
    markerEnd: "url(#arrowhead)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpFieldPositions);
export default __webpack_public_path__ + "static/media/help-field-positions.9348abbcbb4acb99dbd1d68eacf1d983.svg";
export { ForwardRef as ReactComponent };